import { render } from "./HotspotsSlot.vue?vue&type=template&id=1cc0ecee&scoped=true"
const script = {}

import "./HotspotsSlot.vue?vue&type=style&index=0&id=1cc0ecee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc0ecee"]])

export default __exports__